import { useForm } from "react-hook-form";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

function LoginForm(){

    const { handleSubmit, register} = useForm();

    async function onSubmit(data){
        try {
        } catch (err) {
            console.log(err.response);
        }
        
    }
    return (
        <section >
            <Form onSubmit={handleSubmit(onSubmit)}>
                <Form.Group>
                    <Form.Label>Username</Form.Label>
                    <Form.Control type='text' name="username" {...register('username')} />
                </Form.Group>
                <Form.Group>
                    <Form.Label>Password</Form.Label>
                    <Form.Control type='password' name="password" {...register('password')} />
                </Form.Group>
                <Button variant="secondary" type='submit'>Submit</Button>
            </Form>
        </section>
    );
}

export default LoginForm;